// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vvgf","questions":"styles_questions__2cVqS","footer":"styles_footer__kWJGZ"};